// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"12477cde","796":"c502d7e6"}[chunkId] + ".chunk.js";
};